/**
 * Resolve To/Cc for event participant emails (client mirror of
 * server/utils/eventNotificationRecipients.js).
 * Child participants often use @placeholder.local; parent/guardian is the fallback To.
 */
import { isPlaceholderEmail } from "./displayEmail";

function normalizeEmailForCompare(email) {
  const s = email != null ? String(email).trim() : "";
  return s ? s.toLowerCase() : "";
}

function isRealEmail(email) {
  const s = email != null ? String(email).trim() : "";
  return !!(s && !isPlaceholderEmail(s));
}

/**
 * @param {string} participantEmail
 * @param {string} parentEmail
 * @param {{ preferParent?: boolean }} [options]
 *   - default: TO participant when real, else parent; CC parent when both real and different
 *   - preferParent: TO parent when real; CC child when real and different
 * @returns {{ to: string, cc: string }}
 */
export function resolveNotificationEmails(participantEmail, parentEmail, options = {}) {
  const child = participantEmail != null ? String(participantEmail).trim() : "";
  const parent = parentEmail != null ? String(parentEmail).trim() : "";
  const childReal = isRealEmail(child);
  const parentReal = isRealEmail(parent);
  const preferParent = options && options.preferParent === true;

  if (preferParent) {
    if (parentReal) {
      const cc =
        childReal && normalizeEmailForCompare(parent) !== normalizeEmailForCompare(child)
          ? child
          : "";
      return { to: parent, cc };
    }
    if (childReal) return { to: child, cc: "" };
    return { to: "", cc: "" };
  }

  if (childReal) {
    const cc =
      parentReal && normalizeEmailForCompare(parent) !== normalizeEmailForCompare(child)
        ? parent
        : "";
    return { to: child, cc };
  }
  if (parentReal) return { to: parent, cc: "" };
  return { to: "", cc: "" };
}

/**
 * Primary invite/survey email for a getEventParticipants row.
 * Uses participant email when real; otherwise parent_email (event notification fallback).
 * @param {{ email?: string, parent_email?: string }|null|undefined} participant
 * @returns {string}
 */
export function resolveEventParticipantInviteEmail(participant) {
  const { to } = resolveNotificationEmails(participant?.email, participant?.parent_email);
  return to;
}
